import isUndefined from 'lodash/isUndefined'
import set from 'lodash/set'

import type {
  FormErrorProps,
  FormProps,
  PureFormProps,
} from '~/common/types/form'

/** 郵便番号 */
export const postal = (values: FormProps, errors: FormErrorProps = {}) => {
  if (!isUndefined(values.postal) && !/^\d{7}$/.test(values.postal)) {
    errors.postal = `郵便番号の形式に誤りがあります`
  }

  return errors
}

/** URLかファイル添付が必須 */
export const createRequiredUrlOrFile =
  (
    urlKey: keyof Pick<
      FormProps,
      'resumeUrl' | 'portfolioUrl' | 'skillSheetUrl'
    >,
    dataKey: keyof Pick<
      FormProps,
      'resumeFile' | 'portfolioFile' | 'skillSheetFile'
    >
  ) =>
  (values: FormProps, errors: FormErrorProps = {}) => {
    const url = values[urlKey]
    const data = values[dataKey]
    if (isUndefined(url) && isUndefined(data)) {
      errors[urlKey] = `URLを入力するかファイルを添付してください`
      set(
        errors,
        `${dataKey}.data`,
        'URLを入力するかファイルを添付してください'
      )
    }

    return errors
  }

/** 必須 */
export const createRequired =
  (key: keyof PureFormProps) =>
  (values: PureFormProps, errors: FormErrorProps = {}) => {
    if (isUndefined(values[key])) {
      errors[key] = `入力してください`
    }

    return errors
  }

export default {
  createRequiredUrlOrFile,
  createRequired,
  postal,
}
